import { Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper, TimeHelper } from "helpers";
import { isEmpty } from "lodash";
import { IDeliveryOrderDetail, IPaginateApiResponse } from "model";
import moment from "moment";
import { useEffect, useState } from "react";
import { DeliveryOrderActions, PrepareActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import i18n, { _t, translations, I18nTranslator } from "utils/i18n";

interface IProductListProps {
  deliveryTicketHeaderId: string;
}
const PrepareDocumentList = (props: IProductListProps) => {
  const { deliveryTicketHeaderId } = props;
  const dispatch = useAppDispatch();
  const data = useAppSelector(
    (state) => state.DeliveryOrderReducer.deliveryOrderDetail.data
  ) as IPaginateApiResponse<IDeliveryOrderDetail[]>;
  const action = useAppSelector(
    (state) => state.DeliveryOrderReducer.deliveryOrderDetail.action
  );

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    _getDeliveryOrderDetail();
  }, [searchText]);

  const _getDeliveryOrderDetail = (pageNumber = 1) => {
    dispatch(
      DeliveryOrderActions.getDeliveryOrderDetail.request({
        pageNumber: pageNumber,
        pageSize: 100,
        deliveryTicketHeaderId: deliveryTicketHeaderId,
        searchText: searchText,
      })
    );
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "prepareCode",
      headerName: I18nTranslator(translations.receive.prepareCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "preparedDate",
      headerName: I18nTranslator(translations.receive.preparedDate),
      size: "small",
      align: "left",
      renderCell: ({ value }) => (
        <Typography>{TimeHelper.formatDate(value)}</Typography>
      ),
    }),
    TableHelper.createCell({
      field: "doImportCode",
      headerName: I18nTranslator(translations.receive.loCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "description",
      headerName: I18nTranslator(translations.receive.description),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "deliveryDate",
      headerName: I18nTranslator(translations.receive.deliveryDate),
      size: "small",
      align: "left",
      renderCell: ({ value }) => (
        <Typography>{TimeHelper.formatDate(value)}</Typography>
      ),
    }),
    TableHelper.createCell({
      field: "companyCode",
      headerName: I18nTranslator(translations.receive.companyCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "companyName",
      headerName: I18nTranslator(translations.receive.companyName),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "province",
      headerName: I18nTranslator(translations.receive.address),
      size: "small",
      align: "left",
    }),
  ];

  return (
    <AppTable
      loading={action.includes(
        PrepareActions.getPrepareDocumentDetail.requestName
      )}
      data={data}
      columns={COLUMNS}
      onSearch={setSearchText}
      onChangePage={_getDeliveryOrderDetail}
      hideHeader
      hideSearch
      removeActionColumn
      defaultHeaderTable={300}
    />
  );
};

export default PrepareDocumentList;
